import { render } from "./WallCat.vue?vue&type=template&id=0684dbd4&scoped=true&ts=true"
import script from "./WallCat.vue?vue&type=script&lang=ts"
export * from "./WallCat.vue?vue&type=script&lang=ts"

import "./WallCat.vue?vue&type=style&index=0&id=0684dbd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0684dbd4"]])

export default __exports__